module.exports = __webpack_public_path__ + "static/Omid-Abtahi-25243ef234d4a17599c6af7d69f25ec3.jpg";